// import React from "react";
// import { useForm } from "react-hook-form";
// import {
//   Card,
//   Row,
//   Col,
//   Form as BsForm,
//   Button,
//   Alert,
//   InputGroup,
// } from "react-bootstrap";
// import { Eye, EyeOff } from "lucide-react"; 

// export const LoginForm = ({ onLogin }) => {
//   const {
//     register,
//     handleSubmit,
//     formState: { errors, isSubmitting },
//     setError,
//   } = useForm({
//     mode: "onChange",
//   });

//   const [showPassword, setShowPassword] = React.useState(false);

//   const togglePasswordVisibility = () => {
//     setShowPassword((prev) => !prev);
//   };

//   const onSubmit = async (data) => {
//     try {
//       await onLogin(data);
//     } catch (err) {
//       setError("apiError", {
//         type: "manual",
//         message: err.message || "Login failed",
//       });
//     }
//   };

//   return (
//     <BsForm onSubmit={handleSubmit(onSubmit)}>
//       <Card style={{ maxWidth: 500, margin: "2rem auto" }}>
//         <Card.Body>
//           <h4 className="mb-4">🔐 Login</h4>

//           {errors.apiError && (
//             <Alert variant="danger">{errors.apiError.message}</Alert>
//           )}

//           <BsForm.Group className="mb-3">
//             <BsForm.Label>Username</BsForm.Label>
//             <BsForm.Control
//               type="text"
//               placeholder="Enter your username"
//               isInvalid={!!errors.username}
//               {...register("username", { required: "Username is required" })}
//             />
//             <BsForm.Control.Feedback type="invalid">
//               {errors.username?.message}
//             </BsForm.Control.Feedback>
//           </BsForm.Group>

//           <BsForm.Group className="mb-3">
//             <BsForm.Label>Password</BsForm.Label>
//             <InputGroup>
//               <BsForm.Control
//                 type={showPassword ? "text" : "password"}
//                 placeholder="Enter your password"
//                 isInvalid={!!errors.password}
//                 {...register("password", {
//                   required: "Password is required",
//                   minLength: {
//                     value: 6,
//                     message: "Password must be at least 6 characters",
//                   },
//                 })}
//               />
//               <Button
//                 variant="outline-secondary"
//                 type="button"
//                 onClick={togglePasswordVisibility}
//               >
//                 {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
//               </Button>
//               <BsForm.Control.Feedback type="invalid">
//                 {errors.password?.message}
//               </BsForm.Control.Feedback>
//             </InputGroup>
//           </BsForm.Group>

//           <Row className="mt-4">
//             <Col>
//               <Button type="submit" disabled={isSubmitting}>
//                 {isSubmitting ? "Logging in..." : "Login"}
//               </Button>
//             </Col>
//           </Row>
//         </Card.Body>
//       </Card>
//     </BsForm>
//   );
// };


import React from "react";
import { useForm } from "react-hook-form";
import {
  Card,
  Row,
  Col,
  Form as BsForm,
  Button,
  Alert,
  InputGroup,
  Container,
} from "react-bootstrap";
import { Eye, EyeOff } from "lucide-react";

export const LoginForm = ({ onLogin }) => {
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
    setError,
  } = useForm({ mode: "onChange" });

  const [showPassword, setShowPassword] = React.useState(false);
  const togglePasswordVisibility = () => setShowPassword((prev) => !prev);

  const onSubmit = async (data) => {
    try {
      await onLogin(data);
    } catch (err) {
      setError("apiError", {
        type: "manual",
        message: err.message || "Login failed",
      });
    }
  };

  return (
    <div
      style={{
        height: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#f8f9fa",
      }}
    >
      <BsForm onSubmit={handleSubmit(onSubmit)} style={{ width: "100%", maxWidth: 400 }}>
        <Card className="w-100 shadow">
          <Card.Body>
            <h4 className="mb-4 text-center">🔐 Login</h4>

            {errors.apiError && (
              <Alert variant="danger">{errors.apiError.message}</Alert>
            )}

            <BsForm.Group className="mb-3">
              <BsForm.Label>Username</BsForm.Label>
              <BsForm.Control
                type="text"
                placeholder="Enter your username"
                isInvalid={!!errors.username}
                {...register("username", { required: "Username is required" })}
              />
              <BsForm.Control.Feedback type="invalid">
                {errors.username?.message}
              </BsForm.Control.Feedback>
            </BsForm.Group>

            <BsForm.Group className="mb-3">
              <BsForm.Label>Password</BsForm.Label>
              <InputGroup>
                <BsForm.Control
                  type={showPassword ? "text" : "password"}
                  placeholder="Enter your password"
                  isInvalid={!!errors.password}
                  {...register("password", {
                    required: "Password is required",
                    minLength: {
                      value: 6,
                      message: "Password must be at least 6 characters",
                    },
                  })}
                />
                <Button
                  variant="outline-secondary"
                  type="button"
                  onClick={togglePasswordVisibility}
                  tabIndex={-1}
                >
                  {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
                </Button>
                <BsForm.Control.Feedback type="invalid">
                  {errors.password?.message}
                </BsForm.Control.Feedback>
              </InputGroup>
            </BsForm.Group>

            <Row className="mt-4">
              <Col>
                <Button type="submit" className="w-100" disabled={isSubmitting}>
                  {isSubmitting ? "Logging in..." : "Login"}
                </Button>
              </Col>
            </Row>
          </Card.Body>
        </Card>
      </BsForm>
    </div>
  );
};
